import { onMounted, onUnmounted } from 'vue'
import { getAuthMode } from '../services/auth'
import { checkAndRefreshToken } from '../services/tokenRefresh'

export function useTokenRefresh() {
  let refreshInterval = null

  onMounted(() => {
    if (getAuthMode() === 'external') {
      // Initial check
      checkAndRefreshToken()

      // Check every 4 minutes
      refreshInterval = setInterval(() => {
        checkAndRefreshToken()
      }, 4 * 60 * 1000)
    }
  })

  onUnmounted(() => {
    if (refreshInterval) {
      clearInterval(refreshInterval)
    }
  })
}
